import { render, staticRenderFns } from "./CardPlayground.vue?vue&type=template&id=1b4d8503&scoped=true&"
import script from "./CardPlayground.vue?vue&type=script&lang=js&"
export * from "./CardPlayground.vue?vue&type=script&lang=js&"
import style0 from "./CardPlayground.vue?vue&type=style&index=0&id=1b4d8503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d8503",
  null
  
)

export default component.exports